import { cn } from '../../lib/cn';
import { circuitCompletedLabel, parseCircuitKind } from '../../lib/signature/circuitKind';

export const CIRCUIT_STATUS_LABELS = {
  draft: 'À envoyer',
  in_progress: 'En cours',
  awaiting_revision: 'À corriger',
  completed: 'Signé',
  rejected: 'Refusé',
  cancelled: 'Annulé',
  pending: 'En attente',
  signed: 'Signé',
} as const;

type CircuitStatus = keyof typeof CIRCUIT_STATUS_LABELS;

interface Props {
  status: CircuitStatus;
  size?: 'sm' | 'md';
  kind?: string | null;
}

const CONFIG: Record<CircuitStatus, { label: string; className: string }> = {
  draft: { label: CIRCUIT_STATUS_LABELS.draft, className: 'bg-neutral-100 text-neutral-700' },
  in_progress: { label: CIRCUIT_STATUS_LABELS.in_progress, className: 'bg-blue-50 text-blue-700' },
  awaiting_revision: { label: CIRCUIT_STATUS_LABELS.awaiting_revision, className: 'bg-amber-50 text-amber-800' },
  completed: { label: CIRCUIT_STATUS_LABELS.completed, className: 'bg-green-50 text-green-700' },
  rejected: { label: CIRCUIT_STATUS_LABELS.rejected, className: 'bg-red-50 text-red-700' },
  cancelled: { label: CIRCUIT_STATUS_LABELS.cancelled, className: 'bg-neutral-100 text-neutral-600' },
  pending: { label: CIRCUIT_STATUS_LABELS.pending, className: 'bg-amber-50 text-amber-700' },
  signed: { label: CIRCUIT_STATUS_LABELS.signed, className: 'bg-green-50 text-green-700' },
};

export function CircuitStatusBadge({ status, size = 'md', kind }: Props) {
  const cfg = CONFIG[status] ?? CONFIG.rejected;
  const label =
    status === 'completed' || status === 'signed'
      ? circuitCompletedLabel(parseCircuitKind(kind))
      : cfg.label;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs',
        cfg.className,
      )}
    >
      {label}
    </span>
  );
}
